import { Link, useParams } from 'react-router-dom';
import Image from '../../../../atoms/Image';
import Text from '../../../../atoms/Text';
import trending from '../../../../assets/images/flash_empty.svg';
import watchlist from '../../../../assets/images/watchlist_up.svg';
import swap from '../../../../assets/images/swap_grey.svg';
import {
  COMPETITION_ENABLED,
  DEFAULT_OVERVIEW_WALLET,
} from '../../../../helpers/constants';
import { defaultBigTradesSort } from '../../../BigTradesPage';
import { defaultNewPairstSort } from '../../../NewPairsPage';

interface ISidebarNavigationProps {
  onTrending(): void;
  onWatchlist(): void;
  onTrading(): void;
}

const SidebarNavigation = ({
  onTrending,
  onWatchlist,
  onTrading,
}: ISidebarNavigationProps) => {
  const params = useParams();

  return (
    <div className='global_sidebar_mobile__tabs'>
      <div className='global_sidebar_mobile__tabs__tab' onClick={onTrending}>
        <div className='global_sidebar_mobile__tabs__tab__icon'>
          <Image size='s' src={trending} />
        </div>
        <Text size={16} className='text--weight-500 text--grey-400'>
          Trending
        </Text>
      </div>
      <div className='global_sidebar_mobile__tabs__tab' onClick={onWatchlist}>
        <div className='global_sidebar_mobile__tabs__tab__icon'>
          <Image size='s' src={watchlist} />
        </div>
        <Text size={16} className='text--weight-500 text--grey-400'>
          Watchlist
        </Text>
      </div>
      <Link
        to={`/en/wallet-overview/${
          params.chain || 'ETH'
        }/${DEFAULT_OVERVIEW_WALLET}`}
        className='global_sidebar_mobile__tabs__tab'
      >
        <div className='global_sidebar_mobile__tabs__tab__icon icon-wallet' />
        <Text size={16} className='text--weight-500 text--grey-400'>
          Wallet Analyzer
        </Text>
      </Link>
      <div className='global_sidebar_mobile__tabs__tab' onClick={onTrading}>
        <div className='global_sidebar_mobile__tabs__tab__icon'>
          <Image size='s' src={swap} />
        </div>
        <Text size={16} className='text--weight-500 text--grey-400'>
          Swap
        </Text>
      </div>
      <Link
        to={`/new-pairs?chain=ETH&page=1&sort=${defaultNewPairstSort}`}
        className='global_sidebar_mobile__tabs__tab'
      >
        <div className='global_sidebar_mobile__tabs__tab__icon icon-activity' />
        <Text size={16} className='text--weight-500 text--grey-400'>
          New Pairs
        </Text>
      </Link>
      <Link
        to={`/big-trades?chain=ETH&sort=${defaultBigTradesSort}`}
        className='global_sidebar_mobile__tabs__tab'
      >
        <div className='global_sidebar_mobile__tabs__tab__icon icon-collections' />
        <Text size={16} className='text--weight-500 text--grey-400'>
          Big Trades
        </Text>
      </Link>
      {COMPETITION_ENABLED && (
        <Link
          to='/competition/binance'
          className='global_sidebar_mobile__tabs__tab'
        >
          <div className='global_sidebar_mobile__tabs__tab__icon icon-competition' />
          <Text size={16} className='text--weight-500 text--grey-400'>
            Competition
          </Text>
        </Link>
      )}
      <Link to='/help' className='global_sidebar_mobile__tabs__tab'>
        <div className='global_sidebar_mobile__tabs__tab__icon icon-tooltip-circle' />
        <Text size={16} className='text--weight-500 text--grey-400'>
          Help
        </Text>
      </Link>
    </div>
  );
};

export default SidebarNavigation;
